<template>
	<div v-if="modalShow">
		
			<div style="width: 100%; text-align: center" >
				<img
					@click="cancel()"
					style="width: calc(15px + 0.5vw); right: 20px; top: -20px"
					src="@/img/details/cha.png"
					alt=""
				/>
				<div
					style="font-size: calc(14px + 0.4vw); font-weight: 700"
				>
					<!-- {{ $t("尚未登录") }} -->
						尚未登入
				</div>
				<div
					style="width: 90%; margin: auto; background: #f6f4f0"
				>
					<div class="sjbxzt" style="font-size: calc(10px + 0.4vw)">
						<!-- {{ $t("需要先进行登录或注册") }} -->
						需要先進行登入與註冊
					</div>
				</div>
				<div style="height: calc(10px + 1vw)"></div>
				<button
				@click="confirm()"
				>
				<!-- :disabled="isLoading" -->
					<!-- {{ $t("common.login") }} -->
						登入
					<!-- <span
						v-if="isLoading"
						class="spinner-border spinner-border-sm ml-2"
						role="status"
						aria-hidden="true"
					>
					</span> -->
				</button>
			</div>
	</div>
</template>

<script>

export default {
	name: "LoginAlert",
	data(){
		return {
			modalShow: false,
		}
	},
	methods: {
    showDialog() {
      return new Promise((resolve, reject) => {
        this.modalShow = true;
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    confirm() {
      this.modalShow = false;
      this.resolve();
      document.body.removeChild(this.$el);
    },
    cancel() {
      this.modalShow = false;
      this.reject();
      document.body.removeChild(this.$el);
    },
  },
};
</script>

<style scoped>
.sjbzt {
	font-size: calc(14px + 0.4vw) !important;
}
.ckqbb:hover {
  transform: scale(1.001);
  /* 悬浮时放大1.1倍 */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
.annys {
  background: #ffd672;
  border: none;
  font-size: calc(10px + 0.4vw);
}
</style>